import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../util';
import NavigatorMain from './NavigatorMain';
import { hashHistory } from 'react-router';
import {isInvestmentFlag,smSzt} from '../action/investmentAction';
import {ModalTips} from '../components/fundDetail/AlerModle'
import PaymentSuperFund from './PaymentSuperFund';
import FixedInvestmentSuperFund from "./myAssets/payment/FixedInvestmentSuperFund.js";
import ModalPaySup from '../components/Modal/ModalPaySup';
import Password from './myAssets/payment/Password'

class PaymentAllSuperFund extends Component {  
  
  constructor(props) {  
    super(props); 
    this.state = {
      isShowModal: false,
      hideContent: false,
      isShowModal2: false,
      pwdFlag:false,
      data: [],
      keyPasswordVal: "",
      active: this.props.location.state.pageText == "申购" ? 1 : this.props.location.state.pageText == "新建定投计划" ? 2 : 1,
      supRiskVal: ""
    } 
    this.childThis = null;
  }  
  
  componentWillUnmount(){
    this.childThis = null;
  }

  componentWillMount(){
    
  }
  componentDidMount(){
    this.initActive();
    this.hasInvested();
  }

  initActive = () => {
    const sess = sessionStorage.getItem("activeByPaymentAllSuperFund");
    if(sess == "1" || sess == "2") {
      this.setState({
        active: sess
      });
    }
  }

  goBack(){
    hashHistory.goBack();
  }

  handleOk(){
    this.setState({
      isShowModal:false,
      hideContent: false
    });
    const sess = sessionStorage.getItem("modalShowByTip");
    if(sess) {
      let arr = sess.split(",");
      if(arr.indexOf("zxzf_zt") < 0) {
        arr.push("zxzf_zt");
        sessionStorage.setItem("modalShowByTip", arr.join());
      } 
    }else {
      sessionStorage.setItem("modalShowByTip", "zxzf_zt");
    }
  }

  hasInvested(){
    this.props.dispatch(isInvestmentFlag({superFundCode:this.props.location.state.fundCode},(result, riskLevel)=>{
      if(!result){
        const sess = sessionStorage.getItem("modalShowByTip");
        if(sess) {
          let arr = sess.split(",");
          if(arr.indexOf("zxzf_zt") < 0) {
            this.setState({
              isShowModal:true,
              hideContent: true,
              supRiskVal: this.returnLevelFun(riskLevel)
            });
          } 
        }else {
          this.setState({
            isShowModal:true,
            hideContent: true,
            supRiskVal: this.returnLevelFun(riskLevel)
          });
        }
      }
    }))
  }

  returnLevelFun = (val) => {
    if(val == "2") {
      return "R2";
    }
    if(val == "3") {
      return "R3";
    }
    if(val == "4") {
      return "R4";
    }
    return "";
  }

  choseTab(i){
    this.setState({
      active:i,
      isShowModal: false,
      hideContent: false,
      isShowModal2: false,
      pwdFlag:false,
      data: [],
      keyPasswordVal: ""
    })
    sessionStorage.setItem('activeByPaymentAllSuperFund',i);
    this.props.dispatch(smSzt(0))
  }

  onOk(){
    this.setState({
      isShowModal2:false,
      pwdFlag:true
    });
  }

  keyOk = () => {
    if(this.childThis) {
      this.childThis.keyOk();
    }
  }

  getChildThis = (_this) => {
    this.childThis = _this;
  }

  close = (event) => {
    event.stopPropagation()
    this.state.setState({pwdFlag:false})
  }

  onChangePwd = (val) => {
    this.setState({
      keyPasswordVal:val
    })
  }
  
  render() {  
    const {active} = this.state;
    let _props = this.props.location.state;
    return (  
      <div className="container" >
        <div style={{display: this.state.hideContent ? "none" : "block"}}>
          <NavigatorMain>
            {/* <div className="header black">
              <div onClick={()=>this.goBack()}><span className="headerLeftBtn"></span></div>
              <div>在线支付</div>
              <div></div>
            </div> */}
            <div className="headerblacks">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",fontWeight:"bold"}}>在线支付</div>
              <div style={{width:"44px"}}></div>
            </div>
          </NavigatorMain>
          <div className={_props.pageText == "申购" || _props.pageText == "新建定投计划" || _props.pageText == "无定投" ? 'content' : ""}>
            {
              _props.pageText == "申购" || _props.pageText == "新建定投计划" ?
              <div className='headerActive'>
                <div style={{paddingTop:"5px"}}>
                  <div onClick={()=>this.choseTab(1)} style={{fontSize: "20px",fontWeight:"bold"}}>转入</div>
                  <div onClick={()=>this.choseTab(2)} style={{fontSize: "20px",fontWeight:"bold"}}>定投</div>
                </div>
                <div style={{display:"flex",paddingTop:"5px"}}>
                  <div style={{flex:1,textAlign:"center"}}><span className={this.state.active==1?'active':null}></span></div>
                  <div style={{flex:1,textAlign:"center"}}><span className={this.state.active==2?'active':null}></span></div>
                </div>
              </div>
              :
              null
            } 
            <div style={{display: "-webkit-flex", WebkitFlex: 1}}>
              {
                active==1 ?
                <PaymentSuperFund parThis={this} keyPasswordVal={this.state.keyPasswordVal} {..._props} />
                :
                null
              }
              {
                active==2 ?
                <FixedInvestmentSuperFund parThis={this} keyPasswordVal={this.state.keyPasswordVal} {..._props} />
                :
                null
              }
            </div>
          </div>
        </div>
        {
          this.state.isShowModal?
          <ModalTips title='基金投资顾问业务投资者风险揭示书' buttonText='我已知晓风险，确认购买' handleOk={()=>{ this.handleOk() }} verifiedUserInfo={this.props.verifiedUserInfo.content}/>
          :null
        }
        {
          this.state.isShowModal2?
          <ModalPaySup title='利益关联方冲突提示' onOK={()=>{this.onOk()}}  rightButtonTitle='我已知晓' fundName={_props.fundName} data={this.state.data} />
          :null
        }
        {
          this.state.pwdFlag?
          <Password _this={this} ztFlag={true} _type="ZT"/>
          :null
        }      
      </div>
    )
  }
}  
function mapStateToProps(state, ownProps) {
  return {
    verifiedUserInfo: state.verifiedUserInfo
  }
}
export default connect(mapStateToProps)(PaymentAllSuperFund);


// WEBPACK FOOTER //
// ./src/components/PaymentAllSuperFund.js